import config from './config.js'

export default {
  viewparams: {"page":1,"rows":20,"search":"","sort":"map_id","sdir":"asc"},

  // list customer selection from server
  list: function(cb_success) {
    var u = config.baseUrl + 'rest/customers/list?page=' + this.viewparams.page + '&rows=' + this.viewparams.rows + '&sidx=' + this.viewparams.sort + '&sord=' + this.viewparams.sdir;
    if (this.viewparams.search.length > 0) {
      console.log('search: ' + this.viewparams.search);
      u += '&search=' + encodeURIComponent(this.viewparams.search);
    }
    fetch(u,{credentials: 'include'}).then(resp => resp.json()).then(function(data) {
      cb_success(data);
    });
  },

  // load customer entry
  load: function(id,ctrl,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/customers/load?mapid=' + encodeURIComponent(id),'Kunden laden',cb_success);
  },

  // address from customer list
  listcontacts: function(cid,ctrl,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/customers/addresses?cid=' + encodeURIComponent(cid),'Kundenadressen laden',cb_success);
  },

  // list customer extra info entries
  listextras: function(ctrl,cid,start,count,sort,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/customers/extrainfos?cid=' + encodeURIComponent(cid) + '&start=' + start + '&count=' + count + '&sort=' + encodeURIComponent(sort),'Kundenzusatzinfos laden',cb_success);
  },

  listcrmentries: function(ctrl,cid,start,count,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/customers/crmhistory?cid=' + encodeURIComponent(cid) + '&start=' + start + '&count=' + count,'CRM Einträge laden',cb_success);
  },

  listgroups: function(ctrl,cb) {
    config.get(ctrl,config.baseUrl + 'rest/customers/groups?start=0&count=2000','Kundengruppen laden',cb);
  },

  listselections(ctrl,cid,cb) {
    return config.get(ctrl,config.baseUrl + 'rest/customers/selections/' + encodeURIComponent(cid),'Kundensortimente laden',cb);
  }
}
